export const h = {
    homeTitle:"汉语公共神学学会",
    latestMessage:"最新消息",
    learnPublish:"研究出版",
    meeting:"会议讲座",
    latestJournalSecondTitle:"Latest Journal",
    about:"关于我们",
    latestMeeting:"Latest Meeting",
    latestMessageTitle:"Latest News",
    journal:"Academic Journal",
    login: "Login",
    register: "Register",
    userLoginAndRegister: "Author Login & Registration",
    introduce: "Introduction",
    member: "Board Members",
    book: "Bingzhu Series",
    project: "Special Projects",
    annualMeeting: "Annual Conference",
    specialSpeech: "Special Lectures",
    contactSupport: "Contact & Support",
    userLogin: "User Login",
    authorLogin: "Author Login",
    userCenter: "User Center",
    logOut: "Log Out",
    knowMore: "Learn More",
    supportDesc: "To learn more about or support the Society and its ministries and projects, please email info@sfcpt.org",
    journalIntroduction: "Journal Introduction",
    latestJournal: "Latest Issue",
    recommandRead: "Recommended Reading",
    latestSpeech: "Latest Lecture",
    introduceRow1: "The mission of the Society for Chinese Public Theology is: to develop a biblical, universal, and contextualized Chinese public theology system, to promote the Chinese church's understanding and healthy participation in public affairs, and to enhance the overall well-being of society.",
    introduceRow2: "The Society has established an Academic Committee and a Church Development Committee, dedicated to academic research on public theology and related topics, focusing on and promoting the development and practice of public theology in church ministry, theological education, and mission fields; through publishing journals, book series, organizing research projects, hosting lectures and conferences, and other forms to continuously and deeply promote the construction and development of Chinese public theology.",
    introduceRow3: "The inaugural issue of the Society's journal, 'Bingzhu: International Journal of Chinese Public Theology', was published in December 2024.",
    introduceRow4: "From July 22-26, 2024, the Society hosted its first Chinese Public Theology Conference and founding meeting at Calvin Theological Seminary in Michigan, USA, and elected He Guanghu and Luo Bingxiang as President and Vice President.",
    presidentIntroduction: "President Introduction",
    inputEmail: "Please enter your email",
    inputPassword: "Please enter your password",
    validateCode: "Verification Code",

    presidents: [
        {
            name: "He Guanghu",
            pic: require("../../assets/images/firstPerson.png"),
            introduce: "Former Member of the Academic Committee of the Chinese Academy of Social Sciences, Researcher at the Institute of World Religions, Director of the Department of Religious Studies Principles; Member of the University Council and Academic Degree Committee of Renmin University of China, Professor of Religious Studies; author of 'Born in Adversity, Growing in Adversity: Selected Works on Chinese Theology by He Guanghu', 'Sino-Christian Theology', 'Holding a Candle in the Tunnel', 'All Rivers Run to the Sea: Towards a Global Philosophy of Religion', 'The Moon Reflected in a Thousand Rivers: Religion, Society and Life', 'Pluralistic Views of God: An Overview of 20th Century Western Religious Philosophy', etc.",
        },
        {
            name: "Luo Bingxiang",
            pic: require("../../assets/images/FourthPerson.png"),
            introduce: "Steven and Margaret Chu Professor of Chinese Studies at Fuller Theological Seminary, USA, and Academic Director of the Chinese Studies Center. Taught in the Department of Religion and Philosophy at Hong Kong Baptist University for 31 years, and served as Scholar-in-Residence and Senior Professor of Ethics at Logos Evangelical Seminary in Los Angeles. Holds two PhDs from the US: Yale University (1990, Christian Ethics) and State University of New York at Buffalo (1982, Western Moral Philosophy). Author of 'Black and White Distinct: Talks on Christian Ethics', 'The Moral Bottom Line of a Free Society', 'Grandma's Reasoning and Grandpa's Principles: Talking about Ethics', 'The Cross of Homosexuality: Dialogues and Debates among Ethicists'.",
        }],
    userLoginTitle: "User Login & Registration",
    contactSupportRow1: "The Society for Chinese Public Theology (SCPT) is now officially registered as a non-profit organization in the United States.",
    contactSupportRow2: "It has been granted 501(c)(3) tax-exempt status.",
    contactSupportRow3: "To support the Society and our various ministriesand projects, please mail your donation check to our processing center at:",
    contactSupportRow4:"2500 East BeltLine SE, STE G #168",
    contactSupportRowAdd:"Grand Rapids, MI 49546",
    contactSupportRow5:"For more information or to explore other ways of giving, please feel free to reach out to us at",
    contactSupportRowEnd:".",
    committee: "Academic Committee",
    forgetPassword: "Forgot Password",
    search: "Please enter keywords",
    searchResult: "Search Results",
    academicCommittee: [
        {
            name: "He Guanghu",
            pic: require("../../assets/images/firstPerson.png"),
            introduce: "Former Researcher, Institute of World Religions, Chinese Academy of Social Sciences; Professor Emeritus, Renmin University of China.",
        }, {
            name: "Luo Bingxiang",
            pic: require("../../assets/images/FourthPerson.png"),
            introduce: "Steven and Margaret Chu Professor of Chinese Studies, Fuller Theological Seminary, USA; Academic Director, Chinese Studies Center.",
        },
        {
            name: "Clement Chia",
            pic: require("../../assets/images/FourthPerson.png"),
            introduce: "PhD in Theology, University of Exeter, UK. President of Singapore Bible College since 2016.",
        }, {
            name: "Peng Shengyou",
            pic: require("../../assets/images/FourthPerson.png"),
            introduce: "PhD in Theology, University of Edinburgh, UK. Currently teaches at Taiwan Baptist Christian Seminary and serves as Director of the Academic Development Center.",
        }, {
            name: "Kwok Wai Luen",
            pic: require("../../assets/images/FourthPerson.png"),
            introduce: "PhD in Philosophy, King's College London, UK. Currently teaches at Hong Kong Baptist University and serves as Associate Vice-President.",
        }, {
            name: "Tseng Shau Kai",
            pic: require("../../assets/images/FourthPerson.png"),
            introduce: "DPhil in Theology, University of Oxford, UK. Currently holds a teaching position at a university.",
        }, {
            name: "Li Quan",
            pic: require("../../assets/images/FourthPerson.png"),
            introduce: "Luke Quan Li holds a PhD in Christian Ethics from the University of Edinburgh. He is currently a British Academy Postdoctoral Fellow at the University of Edinburgh and a former Humboldt Senior Scholar.",
        }
    ],

}